import React, { Component } from 'react';
import {
  css
} from 'aphrodite';
import { Link } from 'react-router-dom';
import { Button } from '@material-ui/core';
import { Controller } from '../common/Controller';
import { Styles } from './Styles'
import { CommonStyles } from '../styles/Styles';
import Icon from '@material-ui/core/Icon';

export class Stats extends Component {
  constructor(props) {
    super(props);
    this.state = {
    }
  }

  componentDidMount() { }

  render() {
    return (
      <div className={css(Styles.orgDetailContainer)}>
        <div className={css(Styles.orgDetailInnerContainer)}>
          <div className={css(Styles.orgDetailContainerTilte)}>
            <p className={css(Styles.orgDetailContainerTiltContent)}>ORG INFO</p>
          </div>

          {this.props.org &&
            <div className={css(Styles.orgDetailInnerContent)}>
              <div className={css(Styles.ImgOuterContainer)}>
                {!this.props.org.logoUrl &&
                  <Icon
                    className={css(Styles.defaultIcon)}>
                    domain
                  </Icon>
                }
                {this.props.org.logoUrl &&
                  <img
                    src={this.props.org.logoUrl}
                    onError={(e) => {
                      e.target.src = require('../assets/images/error.svg')
                    }}
                    className={css(Styles.ImgContent)} />
                }
              </div>
              <div>
                <p className={css(CommonStyles.headerMemberCountContainer)}>{this.props.org.name}</p>
                {this.props.org.email &&
                  <div className={css(Styles.contactContainer)}>
                    <img src={require('../assets/images/email@.svg')} />
                    <p className={css(Styles.contact)}>{this.props.org.email}</p>
                  </div>
                }
                {this.props.org.phone &&
                  <div className={css(Styles.contactContainer)}>
                    <img src={require('../assets/images/phone.svg')} />
                    <p className={css(Styles.contact)}>{this.props.org.phone}</p>
                  </div>
                }
              </div>
            </div>
          }
        </div>

        <div className={css(Styles.orgDetailInnerContainer, Styles.orgDetailInnerContainerSecondary)}>
          <div className={css(Styles.orgDetailContainerTilte)}>
            <p className={css(Styles.orgDetailContainerTiltContent)}>OVERALL STATUS</p>
          </div>

          <div className={css(Styles.orgDetailInnerContent)}>
            <div>
              <p className={css(Styles.overrallContainerTitle)}>PLACES</p>
              <p className={css(Styles.overrallContainerContent)}>{this.props.places.length}</p>
            </div>
            <div className={css(Styles.overrallContainer)}>
              <p className={css(Styles.overrallContainerTitle)}>CAMERAS</p>
              <p className={css(Styles.overrallContainerContent, Styles.overrallContainerContentSecond)}>{this.props.cams.length}</p>
            </div>
            <div className={css(Styles.overrallContainer)}>
              <p className={css(Styles.overrallContainerTitle)}>TEAM MEMBERS</p>
              <p className={css(Styles.overrallContainerContent, Styles.overrallContainerContentThird)}>{this.props.users.length}</p>
            </div>
          </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Stats.js